import { computed } from "vue";
import { u as useBem } from "./useBem.js";
import { p as pick } from "../utils/pick.js";
const useFormFieldProps = {
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false }
};
const useFormField = (prefix, props) => {
  const computedClasses = useBem(prefix, computed(() => pick(props, ["disabled", "readonly"])));
  return { computedClasses };
};
export {
  useFormField as a,
  useFormFieldProps as u
};
//# sourceMappingURL=useFormField.js.map
